import css from 'styled-jsx/css';

export default css`.masonry-layout, :global(.masonry-autosizer) {
  /* autoprefixer: ignore next */ }
  .masonry-layout::-webkit-scrollbar, :global(.masonry-autosizer)::-webkit-scrollbar {
    display: none; }

:global(body) {
  background-color: #ffffff; }

.masonry-layout {
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  margin: 15px auto 0; }
  .masonry-layout * {
    box-sizing: border-box; }
  @media (min-width: 576px) {
    .masonry-layout {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .masonry-layout {
      max-width: 720px; } }
  @media (min-width: 992px) {
    .masonry-layout {
      max-width: 960px; } }
  @media (min-width: 1216px) {
    .masonry-layout {
      max-width: 960x; } }
  @media (min-width: 576px) {
    .masonry-layout.isWebsite {
      max-width: 540px; } }
  @media (min-width: 768px) {
    .masonry-layout.isWebsite {
      max-width: 540px; } }
  @media (min-width: 992px) {
    .masonry-layout.isWebsite {
      max-width: 750px; } }
  @media (min-width: 1216px) {
    .masonry-layout.isWebsite {
      max-width: 960px; } }

:global(.masonry-autosizer) {
  width: 100% !important;
  height: auto;
  padding-left: 14px;
  padding-right: 14px;
  overflow-x: hidden; }
  @media (min-width: 768px) {
    :global(.masonry-autosizer) {
      width: calc(100% + 20px);
      padding-left: 0;
      padding-right: 0; } }

:global(.masonry-center) {
  display: table;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 50px;
  background: transparent;
  overflow: hidden;
  will-change: auto; }

.loadStop {
  text-align: center;
  color: #999;
  float: left;
  width: calc(100% - 10px);
  padding-bottom: 50px;
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  padding-bottom: calc(100px + env(safe-area-inset-bottom)); }
`